export const SAMPLE_PROMPTS: string[] = [
    'Compare parts SN74AHC245DWR and SN74AHC245DWRE4',
    'Provide environmental information for part JAN2N2222A manufactured by MICROCHIP TECHNOLOGY',
    'Find parts with the following characteristics RES SMD 24.9K OHM 1% 1/4W 0603',
    'What is the COO of VTVS25GSMF-M3-18?',
    'What is the Response Time for LM311J from Rochester?',
    'Can you contrast the features of the V300A12E500BS and V300A12E500B?'
    // Commented by Dhiraj request 04.24.25
    // 'Find alternate parts for 2N2219A'
];
